<div fxLayout="row"
     style=" font-size: 22px; font-family: 'Century Gothic', sans-serif; color: var(--primary); letter-spacing: -0.02rem;">
    <span fxFlex>Διαθέσιμες δηλώσεις</span> <span class="textLink" (click)="navigateToMyAffirmations()">Οι δηλώσεις μου</span>
</div>
<div fxLayout="column" style="margin-top: 20px;">
    <div fxLayout="row wrap" style="width:100%;">
        <div fxLayout="column" class="affirmation mat-elevation-z3" *ngFor="let affirmation of affirmations">
<!--            <div class="consentCard mat-elevation-z3" *ngFor="let affirmation of affirmations">-->
           <app-affirmation-card-template [affirmation]="affirmation" [children]="children"></app-affirmation-card-template>
        </div>
    </div>
</div>
